var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTunisia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8496C24.8366 32.8496 32 25.6862 32 16.8496C32 8.01305 24.8366 0.849609 16 0.849609C7.16344 0.849609 0 8.01305 0 16.8496C0 25.6862 7.16344 32.8496 16 32.8496Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24.5016C20.2262 24.5016 23.6522 21.0756 23.6522 16.8495C23.6522 12.6233 20.2262 9.19727 16 9.19727C11.7738 9.19727 8.34781 12.6233 8.34781 16.8495C8.34781 21.0756 11.7738 24.5016 16 24.5016Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9432 13.9238L18.2559 15.7329L20.382 15.0435L19.0672 16.851L20.3798 18.66L18.2544 17.968L16.9396 19.7755L16.941 17.5405L14.8157 16.8485L16.9418 16.1591L16.9432 13.9238Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7391 21.3712C15.2419 21.3712 13.2174 19.3467 13.2174 16.8494C13.2174 14.3522 15.2419 12.3277 17.7391 12.3277C18.5178 12.3277 19.2504 12.5246 19.8901 12.8712C18.8866 11.8899 17.5144 11.2842 16 11.2842C12.9265 11.2842 10.4348 13.7758 10.4348 16.8494C10.4348 19.9229 12.9265 22.4146 16 22.4146C17.5144 22.4146 18.8867 21.8089 19.8901 20.8276C19.2504 21.1743 18.5178 21.3712 17.7391 21.3712Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.849609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTunisia);
export default __webpack_public_path__ + "static/media/flag_tunisia.c04dd4f1fcdeaf3763d002ced6d6ee40.svg";
export { ForwardRef as ReactComponent };